import { render } from "./AddBranch.vue?vue&type=template&id=3b4f7f6a&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"

import "./AddBranch.vue?vue&type=style&index=0&id=3b4f7f6a&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4f7f6a"],['__file',"src/components/hospitals/branches/AddBranch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b4f7f6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b4f7f6a', __exports__)) {
    console.log('reload')
    api.reload('3b4f7f6a', __exports__)
  }
  
  module.hot.accept("./AddBranch.vue?vue&type=template&id=3b4f7f6a&scoped=true", () => {
    console.log('re-render')
    api.rerender('3b4f7f6a', render)
  })

}


export default __exports__